import { object, string, boolean } from 'yup';
import {
  numbersOnlyRegex,
  verificationCodeLength,
} from '../../mfa-setup/state/constants';

const getFormSchemas = () => {
  const username = string().required(polyglot.t('login.username_required'));

  const password = string().required(polyglot.t('login.password_required'));

  const rememberMe = boolean().required();

  const mfaCode = string()
    .required()
    .matches(numbersOnlyRegex)
    .min(verificationCodeLength)
    .max(verificationCodeLength);

  return {
    usernameOnly: object().shape({
      username,
    }),
    usernamePasswordAndRememberMe: object().shape({
      username,
      password,
      remember_me: rememberMe,
    }),
    usernamePasswordAndMFACode: object().shape({
      username,
      password,
      mfa_code: mfaCode,
    }),
  };
};

export default getFormSchemas;
